module.exports = __webpack_public_path__ + "img/1717382667500-PIRTkeripik opatan.png.5138153b.webp";